export default __webpack_public_path__ + "static/media/retain2.f99fa2b0.svg";